import { createContext, useState } from 'react';


export const DragBoxHoveredCells = createContext([]);
export const DragBoxHoveredCellsDispatch = createContext();

export default function DragBoxHoverProvider({children}){
  const [ dragBoxHoveredCells, setDragBoxHoveredCells ] = useState([]);


  return (
    <DragBoxHoveredCellsDispatch.Provider value={setDragBoxHoveredCells}>
      <DragBoxHoveredCells.Provider value={dragBoxHoveredCells}>
        {children}
      </DragBoxHoveredCells.Provider>
    </DragBoxHoveredCellsDispatch.Provider>
  )

}
